<template>
  <NuxtLink
    class="group relative"
    :to="localePath(data?.buttonUrl || $route.path)"
    :class="{ 'max-lg:hidden': !data.title }"
  >
    <div class="aspect-h-1 aspect-w-1 overflow-hidden">
      <UiLazyImg
        class="h-full w-full transition-all duration-300"
        :class="{ 'lg:group-hover:scale-110': data.title }"
        :src="data.file?.url || ''"
        :src-mobile="data.fileMobile?.url || ''"
        :alt="
          data.file?.alt ||
          removeHTMLTagFromString(data.title || '') ||
          $t('image')
        "
        img-classes="object-cover"
      />
    </div>
    <div
      v-if="data.title"
      class="card-title bg-black px-5 py-2.5 text-white max-lg:text-center lg:absolute lg:bottom-9 lg:left-0"
      v-html="data.title"
    />
    <div
      v-if="data.text"
      class="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2"
      v-html="data.text"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import { BlockSliderSlide } from "~/types/api/block.types";
import { removeHTMLTagFromString } from "~/utils";

const localePath = useLocalePathPolyfill();

defineProps<{
  data: BlockSliderSlide;
}>();
</script>

<style scoped>
.card-title:deep(p) {
  @apply ui-text-sm tracking-[1.2px];
}
</style>
